// @flow
import { COUNTRY_POI } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_COUNTRY_POI } from 'Utils/request/requestDictionary';

export const countryPoiResolver = {
  name: COUNTRY_POI,
  resolve(appContext: AppContext, props: { countryId: string, isForFamily: boolean } = {}) {
    const { countryId, isForFamily } = props;
    const countryArgs = `countryId:"${countryId}" isForFamily:${isForFamily.toString()}`;

    const query = `query {
      config {
        common { close }
      }
      countryPoi(${countryArgs}) {
        title
        description
        media {
          mediaUrl
          mediaAlt
        }
        associatedProducts {
          name
          href
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_COMMON_COUNTRY_POI,
      strictErrors: false,
    });
  },
};
